import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";


function GenerateLinkwithdrawal() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(500);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPageGH, setcurrentPageGH] = useState(1);
  const [listPerpageGH, setlistPerpageGH] = useState(500);
  const [leftreferralApiGH, setleftreferralApiGH] = useState([]);
  const [radioboxPH, setRadioboxPH] = useState("");
  const [radioboxGH, setRadioboxGH] = useState("");
  const [searchGH, setSearchGH] = useState("");
  const [searchPH, setSearchPH] = useState("");
  const [selectedPH, setSelectedPH] = useState([]);
  const [selectedPHID, setSelectedPHID] = useState([]);
  const [selectedGH, setSelectedGH] = useState([]);
  const [selectedGHID, setSelectedGHID] = useState([]);
  const [fromDateGH, setFromDateGH] = useState("");
  const [toDateGH, setToDateGH] = useState("");
  const [fromDatePH, setFromDatePH] = useState("");
  const [toDatePH, setToDatePH] = useState("");



  const referral_API = async () => {
    setisLoading(true);
    try {
      //PH LIST 
      let responceRight = await API?.post(

        "/GetuserforCreateLink",
        {
          loginid: userId,
          type: "PH_users_500",
          uid: searchPH,
          fdate: fromDatePH,
          tdate: toDatePH,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight?.data?.data[0];

      setleftreferralApi([]);
      let arrayLeft = responceRight.map((item, index) => ({
        sr: index + 1,
        Uid: item.uid,
        name: item.name,
        paymentcount: item.paymentcount,
        remainday: item.remainday,
        dd: item.dd,
      }));
      setleftreferralApi(arrayLeft);


      //gh LIST
      let responceRightGH = await API?.post(
        "/GetuserforCreateLink",
        {
          loginid: userId,
          type: "GH_users_withdrawal",
          uid: searchGH,
          fdate: fromDateGH,
          tdate: toDateGH,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRightGH = responceRightGH?.data?.data[0];

      setleftreferralApiGH([]);
      // let arrayLeftGH = [];
      let arrayLeftGH = responceRightGH.map((item, index) => ({
        sr: index + 1,
        Uid: item.uid,
        name: item.name,
        paymentcount: item.paymentcount,
        remainday: item.remainday,
        dd: item.dd,
      }));
      console.log("arrayLeftGH-->", arrayLeftGH);
      setleftreferralApiGH(arrayLeftGH);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const handlePHCheckboxChange = (uid, RowId) => {
    setSelectedPHID((prevID) => {
      if (prevID.includes(RowId)) {
        // uncheck row
        setSelectedPH((prev) => {
          const index = prevID.indexOf(RowId);
          // Remove only one occurrence of uid (mapped to that RowId)
          let newArr = [...prev];
          newArr.splice(index, 1);
          return newArr;
        });
        return prevID.filter((id) => id !== RowId);
      } else {
        // check row
        setSelectedPH((prev) => [...prev, uid]); // allow duplicates
        return [...prevID, RowId];
      }
    });
  };
  const handleSelectAllPH = (e) => {
    if (e.target.checked) {
      const allRowIds = leftreferralApi.map((item) => item.sr);
      const allUserIds = leftreferralApi.map((item) => item.Uid);

      setSelectedPHID(allRowIds);
      setSelectedPH(allUserIds);
    } else {
      setSelectedPHID([]);
      setSelectedPH([]);
    }
  };


  const handleGHCheckboxChange = (uid, RowId) => {
    setSelectedGHID((prevID) => {
      if (prevID.includes(RowId)) {
        // uncheck row
        setSelectedGH((prev) => {
          const index = prevID.indexOf(RowId);
          // Remove only one occurrence of uid (mapped to that RowId)
          let newArr = [...prev];
          newArr.splice(index, 1);
          return newArr;
        });
        return prevID.filter((id) => id !== RowId);
      } else {
        // check row
        setSelectedGH((prev) => [...prev, uid]); // allow duplicates
        return [...prevID, RowId];
      }
    });
  };

  const handleSelectAllGH = (e) => {
    if (e.target.checked) {
      const allRowIds = leftreferralApiGH.map((item) => item.sr);
      const allUserIds = leftreferralApiGH.map((item) => item.Uid);

      setSelectedGHID(allRowIds);
      setSelectedGH(allUserIds);
    } else {
      setSelectedGHID([]);
      setSelectedGH([]);
    }
  };


  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  const indexOfLastPostGH = currentPageGH * listPerpageGH;
  const indexOfFirstPageGH = indexOfLastPostGH - listPerpageGH;
  const currentPostleftGH = leftreferralApiGH.slice(
    indexOfFirstPageGH,
    indexOfLastPostGH
  );

  const columnsPH = React.useMemo(
    () => [
      {
        Header: () => (
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              checked={selectedPHID.length === leftreferralApi.length && leftreferralApi.length > 0}
              onChange={handleSelectAllPH}
            />
          </div>
        ),
        id: "checkbox",
        Cell: ({ row }) => (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedPHID.includes(row.original.sr)} // ✅ updates correctly
              onChange={() => handlePHCheckboxChange(row.original.Uid, row.original.sr)}
            />
          </div>
        ),
      },
      // { Header: "#", accessor: "sr" },
      { Header: "User Id", accessor: "Uid" },
      { Header: "Name", accessor: "name" },
      { Header: "Date", accessor: "dd" },
    ],
    [selectedPH] // 👈 ensures re-render when selection changes
  );


  const columnsGH = React.useMemo(
    () => [
      {
        Header: () => (
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              checked={selectedGHID.length === leftreferralApiGH.length && leftreferralApiGH.length > 0}
              onChange={handleSelectAllGH}
            />
          </div>
        ),
        id: "checkbox",
        Cell: ({ row }) => (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedGHID.includes(row.original.sr)} // ✅ updates correctly
              onChange={() => handleGHCheckboxChange(row.original.Uid, row.original.sr)}
            />
          </div>
        ),
      },
      // { Header: "#", accessor: "sr" },
      { Header: "User Id", accessor: "Uid" },
      { Header: "Name", accessor: "name" },
      { Header: "Remain Count", accessor: "paymentcount" },
      { Header: "Remain Day", accessor: "remainday" },
      { Header: "Date", accessor: "dd" },
    ],
    [selectedGH] // 👈 ensures re-render when selection changes
  );


  const generateLink = async (id) => {
    try {
      if (window.confirm("Are you sure, you want to update..?")) {
        if (selectedPH.length != selectedGH.length) {
          toast.error("PH Selected Number And Gh  Selected Number should be same");
          return;
        }
        let response;
        for (let i = 0; i < selectedPH.length; i++) {
          const ph = selectedPH[i];
          const gh = selectedGH[i];
          if (gh == ph) {
            toast.error("PH User ID And Gh user ID Should not be same");
          } else if (gh != ph) {
            response = await API?.post(
              "/Generate_HelpLink_Withdrawal",
              {
                loginid: userId,
                // ph_uid: radioboxPH,
                // gh_uid: radioboxGH,
                ph_uid: ph,
                gh_uid: gh,
              },
              {
                headers: {
                  Authorization: jwt_token,
                },
              }
            );
          }
        }

        const result = response?.data?.data?.result;
        if (result === "Done !!") {
          toast.success("Link Generate Successfully !!");
          referral_API();
          setSelectedGH([]);
          setSelectedGHID([]);
          setSelectedPH([]);
          setSelectedPHID([]);
        } else {
          toast.error(result);
        }

      }
    } catch (e) {
      console.log("Error in UpdateLinkId_Api", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };



  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="row">
                  <h2>Generate Link withdrawal</h2>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div class="panel-heading">
                      <h4 class="panel-title">PH List - ( {selectedPH.join(", ")} )</h4>
                    </div>{" "}
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-lg-3 col-xl-3 col-md-3">
                          <label>User ID</label>
                          <br />
                          <input
                            type="text"
                            id="userid"
                            ng-model="p.userid"
                            class="form-control in-ip-1"
                            placeholder="Enter User Id"
                            onChange={(e) => setSearchPH(e.target.value)}
                          />
                        </div>
                        <div class="col-lg-3 col-xl-3 col-md-3">
                          <label>From Date</label>
                          <br />
                          <input
                            class="form-control in-ip-1"
                            onChange={(e) => setFromDatePH(e.target.value)}
                            value={fromDatePH}
                            id="todate"
                            name="todate"
                            type="date"
                          />
                        </div>
                        <div class="col-lg-3 col-xl-3 col-md-3">
                          <label>To Date</label>
                          <br />
                          <input
                            class="form-control in-ip-1"
                            value={toDatePH}
                            onChange={(e) => setToDatePH(e.target.value)}
                            id="fdate"
                            name="fdate"
                            type="date"
                          />
                        </div>
                        <div class="col-lg-2 col-xl-2 col-md-2 mt-4">
                          <input
                            type="button"
                            id="btnsearch"
                            onClick={() => referral_API()}
                            class="btn btn-primary"
                            value="Search"
                          />
                        </div>
                      </div>
                      <div class="row">
                        {isLoading ? (
                          <Spinner />
                        ) : (
                          <div className="col-md-12">
                            <Table
                              data={currentPostleft}
                              columns={columnsPH}
                            />

                            <Table_Buttons
                              indexOfFirstPage={indexOfFirstPage}
                              indexOfLastPost={indexOfLastPost}
                              setcurrentPage={setcurrentPage}
                              currentPage={currentPage}
                              totalData={leftreferralApi.length}
                              listPerpage={listPerpage}
                              handleRowsPerPageChange={setlistPerpage}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6" >
                    <div class="panel-heading">
                      <h4 class="panel-title">GH List - ( {selectedGH.join(", ")} )</h4>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-lg-3 col-xl-3 col-md-3">
                          <label>User ID</label>
                          <br />
                          <input
                            type="text"
                            id="userid"
                            ng-model="p.userid"
                            class="form-control in-ip-1"
                            placeholder="Enter User Id"
                            onChange={(e) => setSearchGH(e.target.value)}
                          />
                        </div>
                        <div class="col-lg-3 col-xl-3 col-md-3">
                          <label>From Date</label>
                          <br />
                          <input
                            class="form-control in-ip-1"
                            onChange={(e) => setFromDateGH(e.target.value)}
                            value={fromDateGH}
                            id="todate"
                            name="todate"
                            type="date"
                          />
                        </div>
                        <div class="col-lg-3 col-xl-3 col-md-3">
                          <label>To Date</label>
                          <br />
                          <input
                            class="form-control in-ip-1"
                            value={toDateGH}
                            onChange={(e) => setToDateGH(e.target.value)}
                            id="fdate"
                            name="fdate"
                            type="date"
                          />
                        </div>
                        <div class="col-lg-2 col-xl-2 col-md-2 mt-4">
                          <input
                            type="button"
                            id="btnsearch"
                            onClick={() => referral_API()}
                            class="btn btn-primary"
                            value="Search"
                          />
                        </div>
                      </div>
                      <div class="row">
                        {isLoading ? (
                          <Spinner />
                        ) : (
                          <div className="col-md-12">
                            <Table
                              data={currentPostleftGH}
                              columns={columnsGH}
                            />

                            <Table_Buttons
                              indexOfFirstPage={indexOfFirstPageGH}
                              indexOfLastPost={indexOfLastPostGH}
                              setcurrentPage={setcurrentPageGH}
                              currentPage={currentPageGH}
                              totalData={leftreferralApiGH.length}
                              listPerpage={listPerpageGH}
                              handleRowsPerPageChange={setlistPerpageGH}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 text-center">
              <input
                type="button"
                onClick={() => {
                  generateLink();
                }}
                class="btn btn-md btn-success"
                value="Generate Link"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GenerateLinkwithdrawal;
